import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import IdDocsSection from "@/components/IdDocsSection";

const FIELDS = [
  ["code", "Codice dipendente"], ["company", "Ditta"], ["role_title", "Qualifica / Mansione"],
  ["department", "Postazione / Reparto"], ["tax_code", "Codice fiscale"], ["phone", "Telefono"],
  ["email", "Mail"], ["birth_city", "Città di nascita"], ["birth_province", "Provincia di nascita"],
  ["birth_date", "Data di nascita"], ["residence_city", "Comune di residenza"],
  ["residence_province", "Provincia residenza"], ["address", "Indirizzo di residenza"],
  ["street_number", "Numero civico"], ["hire_date", "Data assunzione"],
];

export const EmployeeCard = ({ employeeId, onClose, onOpenSummary }) => {
  const [e, setE] = useState(null);

  useEffect(() => {
    api.get(`/employees/${employeeId}`).then((r) => setE(r.data))
      .catch((err) => toast.error(errMsg(err)));
  }, [employeeId]);

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="rounded-sm sm:max-w-2xl max-h-[88vh] overflow-y-auto" data-testid="employee-card">
        <DialogHeader>
          <DialogTitle className="font-head">
            {e ? `${e.last_name} ${e.first_name}` : "Scheda dipendente"}
            {e && (
              <div className="mt-1">
                <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded-sm ${e.active
                  ? "bg-emerald-100 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-300"
                  : "bg-rose-100 text-rose-900 dark:bg-rose-950 dark:text-rose-300"}`}>
                  {e.active ? "ATTIVO" : "NON ATTIVO"}
                </span>
              </div>
            )}
          </DialogTitle>
        </DialogHeader>

        <div className="grid sm:grid-cols-2 gap-x-4 gap-y-2">
          {FIELDS.map(([k, l]) => (
            <div key={k} className="border-b border-border pb-1.5" data-testid={`card-${k}`}>
              <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{l}</div>
              <div className="text-sm">{e?.[k] || "—"}</div>
            </div>
          ))}
        </div>

        <IdDocsSection employeeId={employeeId} />

        {onOpenSummary && (
          <Button className="rounded-sm font-semibold" onClick={() => onOpenSummary(employeeId)} data-testid="card-open-summary">
            Vedi riepilogo presenze
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EmployeeCard;
